export default "__VITE_ASSET__C1h8k_ga__"